import { useState, useEffect } from 'react';
export function useDeviceWidth() {
    var _a, _b, _c;
    var _d = useState(window.innerWidth || ((_c = (_b = (_a = document.documentElement).getBoundingClientRect) === null || _b === void 0 ? void 0 : _b.call(_a)) === null || _c === void 0 ? void 0 : _c.width) || 0), width = _d[0], setWidth = _d[1];
    useEffect(function () {
        function handleResize() {
            setWidth(window.innerWidth);
        }
        window.addEventListener('resize', handleResize);
        handleResize();
        return function () { return window.removeEventListener('resize', handleResize); };
    }, []);
    return width;
}
